export default {
      id: "notifications__geozone.exit-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#notifications__geozone.exit",
      toString: function () {
        return this.url;
      }
    }